export const PASSWORD_CHANGED = 'Password has been successfully changed'
